import './NoticesBanner.d41d8cd98f00b204e9800998ecf8427e.css';
export default {};